if (!customElements.get('tech-hero-video')) {
  customElements.define('tech-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.desktopTemplate = this.querySelector('template[data-desktop]');
      this.mobileTemplate = this.querySelector('template[data-mobile]');
      if (!this.desktopTemplate) return;

      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.onBreakpoint = () => this.selectVideo();
      this.onPlayback = () => this.updatePlayback();
      this.breakpoint.addEventListener('change', this.onBreakpoint);
      this.reducedMotion.addEventListener('change', this.onPlayback);
      document.addEventListener('visibilitychange', this.onPlayback);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.updatePlayback();
      });
      this.selectVideo();
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.breakpoint?.removeEventListener('change', this.onBreakpoint);
      this.reducedMotion?.removeEventListener('change', this.onPlayback);
      document.removeEventListener('visibilitychange', this.onPlayback);
      this.clearVideo();
    }

    selectVideo() {
      const template = this.breakpoint.matches && this.mobileTemplate
        ? this.mobileTemplate : this.desktopTemplate;
      if (template === this.activeTemplate) return;

      this.clearVideo();
      this.activeTemplate = template;
      const source = template.content.querySelector('video');
      if (!source) return;
      this.video = source.cloneNode(true);
      this.video.muted = true;
      this.onReady = () => this.classList.add('is-ready');
      this.onError = () => this.classList.remove('is-ready');
      this.video.addEventListener('loadeddata', this.onReady);
      this.video.addEventListener('error', this.onError, true);
      this.appendChild(this.video);
      if (this.video.poster) this.classList.add('is-ready');
      this.updatePlayback();
    }

    updatePlayback() {
      if (!this.video) return;
      if (this.inView && !document.hidden && !this.reducedMotion.matches) {
        this.video.play()?.catch(() => {
          // Keep the poster or image when the browser blocks autoplay.
        });
      } else {
        this.video.pause();
      }
    }

    clearVideo() {
      if (this.video) {
        this.video.removeEventListener('loadeddata', this.onReady);
        this.video.removeEventListener('error', this.onError, true);
        this.video.pause();
        this.video.remove();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
        this.video = null;
      }
      this.activeTemplate = null;
      this.classList.remove('is-ready');
    }
  });
}
